





















import { Component, Vue, Prop } from 'vue-property-decorator'
import BackButton from '@/components/BackButton.vue'

@Component({
  components: {
    BackButton
  }
})
export default class InstructionsView extends Vue {}
